export var partnersNotPermitted = [
    "RZaEwhPA",
    "Ak6CA6PA",
    "1LExkoPA",
    "zTlJsGPA",
    "hSi2cBPA", // Continent LLC
];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU3VibWl0V2FiYUVtYmVkZGVkRmxvdy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIlN1Ym1pdFdhYmFFbWJlZGRlZEZsb3cudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE1BQU0sQ0FBQyxJQUFNLG9CQUFvQixHQUFHO0lBQ2xDLFVBQVU7SUFDVixVQUFVO0lBQ1YsVUFBVTtJQUNWLFVBQVU7SUFDVixVQUFVLEVBQUUsZ0JBQWdCO0NBQzdCLENBQUMifQ==